export default __webpack_public_path__ + "aa3092c.png";